import React from 'react';
import LinearScaleIcon from '@mui/icons-material/LinearScale';

import { hasTrussDesignPermission } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../monitor';
import { selectReferenceLine } from '../../../../store/actions/selectActions';
import { getActiveComponentDesign } from '../../../../store/selectors/getActiveComponentDesignSelector';
import { getReferenceLineLongNamesByGuidForActiveComponent } from '../../../../store/selectors/getReferenceLineLongNamesByGuidForActiveComponentSelector';
import { EventPosition } from '../../../../three/util/events/types';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { SceneMenuItem } from '../common/SceneMenuItem';

export function ReferenceLineMenu(props: { guids: readonly string[]; position: EventPosition }) {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const canEditTrusses = useAppSelector(hasTrussDesignPermission);
  const componentDesign = useAppSelector(getActiveComponentDesign);
  const lineNames = useAppSelector(getReferenceLineLongNamesByGuidForActiveComponent);
  if (componentDesign == null || !canEditTrusses || !lineNames) return null;

  const referenceLines = componentDesign.component.referenceLines?.filter(({ guid }) => props.guids.includes(guid));
  if (!referenceLines) return null;

  const children = referenceLines.map((line) => (
    <SceneMenuItem
      key={`${line.guid}-select`}
      id={`reference-line-menu-item-${line.guid}`}
      text={lineNames.get(line.guid) ?? 'Unknown Line'}
      icon={<LinearScaleIcon />}
      onClick={() => {
        dispatch(selectReferenceLine(line, { clickPosition: props.position.worldPosition }));
        monitor.recordInteraction('Reference Line disambiguation menu item clicked');
      }}
    />
  ));

  return <SceneMenuContent>{children}</SceneMenuContent>;
}
